(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["floory-floor-calculator"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('floor-calculator')) {
    customElements.define(
      'floor-calculator',
      class FloorCalculator extends HTMLElement {
        connectedCallback() {
          this.rooms = this.querySelector('[data-rooms]');
          this.template = this.querySelector('[data-room-template]');
          this.productPicker = this.querySelector('[data-product-picker]');
          this.cartButton = this.querySelector('[data-add-to-cart]');
          this.cartStatus = this.querySelector('[data-cart-status]');
          this.price = Number(this.dataset.price) || 599;
          this.vat = Number(this.dataset.vat) || 21;
          this.querySelector('[data-add-room]').addEventListener('click', () => this.addRoom());
          this.querySelector('[data-show-products]')?.addEventListener('click', (event) => {
            this.productPicker.hidden = false;
            event.currentTarget.hidden = true;
            this.productPicker.querySelector('input:not([disabled])')?.focus();
          });
          this.cartButton?.addEventListener('click', () => this.addToCart());
          this.addEventListener('input', () => this.calculate());
          this.addEventListener('change', (event) => {
            this.calculate();
            if (event.target.matches('[data-product-variant]')) {
              this.selectedVariantId = event.target.value;
              this.cartButton.disabled = this.cartQuantity < 1;
              this.cartStatus.textContent = '';
            }
          });
          this.addEventListener('click', (event) => {
            const removeButton = event.target.closest('[data-remove-room]');
            if (removeButton) this.removeRoom(removeButton);
          });
          this.calculate();
        }

        addRoom() {
          const fragment = this.template.content.cloneNode(true);
          this.rooms.appendChild(fragment);
          this.refreshRoomLabels();
          this.calculate();
        }

        removeRoom(button) {
          button.closest('[data-room-row]').remove();
          this.refreshRoomLabels();
          this.calculate();
        }

        refreshRoomLabels() {
          const label = this.querySelector('[data-room-title]').textContent.replace(/\s\d+$/, '');
          this.querySelectorAll('[data-room-row]').forEach((room, index) => {
            room.querySelector('[data-room-title]').textContent = `${label} ${index + 1}`;
            const remove = room.querySelector('[data-remove-room]');
            if (remove) remove.hidden = index === 0 && this.querySelectorAll('[data-room-row]').length === 1;
          });
        }

        calculate() {
          const roomArea = Array.from(this.querySelectorAll('[data-room-row]')).reduce((sum, room) => {
            const length = Number(room.querySelector('[data-room-length]').value) || 0;
            const width = Number(room.querySelector('[data-room-width]').value) || 0;
            return sum + length * width;
          }, 0);
          const waste = Number(this.querySelector('[data-waste]').value) || 0;
          const requiredArea = Math.ceil(roomArea * (1 + waste / 100));
          const priceExVat = requiredArea * this.price;
          const priceIncVat = priceExVat * (1 + this.vat / 100);
          const areaFormat = new Intl.NumberFormat('cs-CZ', { minimumFractionDigits: 0, maximumFractionDigits: 2 });
          const priceFormat = new Intl.NumberFormat('cs-CZ', { maximumFractionDigits: 0 });
          this.querySelector('[data-room-area]').textContent = areaFormat.format(roomArea);
          this.querySelector('[data-required-area]').textContent = areaFormat.format(requiredArea);
          this.querySelector('[data-price-ex-vat]').textContent = priceFormat.format(priceExVat);
          this.querySelector('[data-price-inc-vat]').textContent = priceFormat.format(priceIncVat);
          this.cartQuantity = requiredArea;
          const cartQuantity = this.querySelector('[data-cart-quantity]');
          if (cartQuantity) cartQuantity.textContent = areaFormat.format(requiredArea);
          if (this.cartButton) this.cartButton.disabled = !this.selectedVariantId || requiredArea < 1;
        }

        async addToCart() {
          if (!this.selectedVariantId || this.cartQuantity < 1 || this.cartButton.disabled) return;

          this.cartButton.disabled = true;
          this.cartButton.setAttribute('aria-busy', 'true');
          this.cartStatus.textContent = this.cartButton.dataset.addingLabel;

          try {
            const response = await fetch(this.dataset.cartAddUrl, {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json'
              },
              body: JSON.stringify({
                items: [{ id: Number(this.selectedVariantId), quantity: this.cartQuantity }]
              })
            });

            if (!response.ok) throw new Error(`Cart request failed: ${response.status}`);
            window.location.assign(this.dataset.cartUrl);
          } catch {
            this.cartStatus.textContent = this.cartButton.dataset.errorLabel;
            this.cartButton.disabled = false;
            this.cartButton.removeAttribute('aria-busy');
          }
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
